module.exports = __webpack_public_path__ + "img/news.89cf29dd.png";